import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { currency } from '../../utils';
import { ArrowDown } from '../icon/icons/ArrowDown';
import { ArrowUp } from '../icon/icons/ArrowUp';
import { Typography } from '../Typography';

interface AverageChangeProps {
  average?: number | string;
  direction?: string;
  percentageChange?: number;
  useCurrency?: boolean;
  useDirectionIcon?: boolean;
}

const StyledAverageChange = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.xs};
  `};
`;

export const AverageChange: FC<AverageChangeProps> = ({
  average,
  direction,
  percentageChange,
  useCurrency,
  useDirectionIcon,
  ...rest
}) => {
  if (!average) {
    return <></>;
  }

  return (
    <StyledAverageChange {...rest}>
      {average && (
        <Typography component="p" variant="titleLarge">
          {useCurrency ? currency(average) : average}
        </Typography>
      )}
      {direction || percentageChange ? (
        <Typography component="p" variant="lead" color={direction === 'up' ? 'valid' : 'invalid'}>
          {useDirectionIcon ? (
            <>{direction === 'up' ? <ArrowUp size="default" /> : <ArrowDown size="default" />}</>
          ) : (
            <>{direction === 'up' ? '+' : '-'}</>
          )}
          {percentageChange && <>{percentageChange}%</>}
        </Typography>
      ) : (
        ''
      )}
    </StyledAverageChange>
  );
};
